module.exports = __webpack_public_path__ + "img/ehrenoffiziere.d691211f.svg";